import { bool, func, oneOfType, string, number } from 'prop-types'
import React from 'react'
import '../../../components/library/buttons/Checkbox.scss'
import DeleteIcon from '../../../components/library/graphics/DeleteIcon'
import Skeleton from '../../../components/library/loaders/Skeleton'

const AssignedListItem = ({ id, label, isLocked, onUnassignClicked }) => {

    const elementId = id ? `item-assigned-${id}` : 'loader'

    const handleClick = () => {
        if (id && onUnassignClicked) {
            onUnassignClicked(id)
        }
    }

    return (
        <label className='spark-cb px-1 py-1 office-list-item' onClick={() => handleClick()}>
            {(!isLocked && label && id) ?
                <DeleteIcon />
                :
                <div className='remove-assignment-placeholder' />
            }
            {label && id ?
                <label htmlFor={elementId} className='cb-label p2 ml-2' title={label}>
                    <span className='is-unselectable truncate-text'>{label}</span>
                </label>
                :
                <label htmlFor={elementId} className='cb-label p2 ml-2'>
                    <span><Skeleton width='200px' /></span>
                </label>
            }
        </label>
    )
}

AssignedListItem.propTypes = {
    id: oneOfType([string, number]),
    label: string,
    isLocked: bool,
    onUnassignClicked: func
}

export default AssignedListItem